
import React from "react";
import MainLayout from "../../components/layout/MainLayout";
import ProjectDetail from "../../components/admin/ProjectDetail";

const AdminProjectDetail: React.FC = () => {
  return (
    <MainLayout>
      <ProjectDetail />
    </MainLayout>
  );
};

export default AdminProjectDetail;
